<section class="container-wrapper">
    <h1 class="module-heading">
      {{ 'pages.config-all.config-cards.config-print-cards.header' | translate }}
      <div class="loading-spinner" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="20">
        </mat-progress-spinner>
      </div>
    </h1>
  
    <div [formGroup]="selectedCodeStyleForm">
      <app-form-select
        class="code-type-selector"
        label="{{ 'pages.config-all.config-cards.config-print-cards.code-options.label' | translate }}"
        [placeholder]="'pages.config-all.config-cards.config-print-cards.code-options.placeholder' | translate"
        [noFormControlBorder]="true"
        [options]="codeStyleOptions"
        [displayMessages]="false"
        formControlName="selectedCodeStyle"
        (change)="selectedCodeStyleChanged($event)">
      </app-form-select>
    </div>
  
    <div *ngIf="selectedCodeStyle && !formLoading" [formGroup]="printTemplateForm" class="form">
      <section formGroupName="name">
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.name.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" formControlName="display" [showMessages]="false"></app-form-checkbox>
        </div>
        <div class="row" *ngIf="nameDisplay.value">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.name.namePositionX' | translate }}"
            formControlName="x" data-cy="namePositionX">
            <app-form-error *ngIf="namePositionX.touched && namePositionX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="namePositionX.touched && namePositionX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.name.namePositionY' | translate }}"
            formControlName="y" data-cy="namePositionY">
            <app-form-error *ngIf="namePositionY.touched && namePositionY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="namePositionY.touched && namePositionY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>

          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.name.maxWidth' | translate }}" formControlName="maxWidth" data-cy="nameMaxWidth">
            <app-form-error *ngIf="nameMaxWidth.touched && nameMaxWidth.hasError('required')">
            {{ 'pages.config-all.config-cards.config-print-cards.error.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="nameMaxWidth.touched && nameMaxWidth.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.error.invalid' | translate }}
              </app-form-error>
          </app-form-input>

          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.name.fontSize' | translate }}" formControlName="fontSize" data-cy="nameFontSize">
            <app-form-error *ngIf="nameFontSize.touched && nameFontSize.hasError('required')">
            {{ 'pages.config-all.config-cards.config-print-cards.error.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="nameFontSize.touched && nameFontSize.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.error.invalid' | translate }}
              </app-form-error>
          </app-form-input>
        </div>
        <div class="row" *ngIf="nameDisplay.value" [formGroup]="exampleCardForm">
          <app-form-input class="text-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.name.exampleFirstName' | translate }}"
            formControlName="firstName" data-cy="exampleFirstName">
            <app-form-error *ngIf="exampleFirstName.touched && exampleFirstName.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
          </app-form-input>

          <app-form-input class="text-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.name.exampleLastName' | translate }}"
            formControlName="lastName" data-cy="exampleLastName">
            <app-form-error *ngIf="exampleLastName.touched && exampleLastName.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
      </section>
  
      <section formGroupName="photo">
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.photo.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" formControlName="display" [showMessages]="false"></app-form-checkbox>
        </div>
        <div class="row" *ngIf="photoDisplay.value">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.photo.photoPositionX' | translate }}"
            formControlName="x" data-cy="photoPositionX">
            <app-form-error *ngIf="photoPositionX.touched && photoPositionX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="photoPositionX.touched && photoPositionX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
      
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.photo.photoPositionY' | translate }}"
            formControlName="y" data-cy="photoPositionY">
            <app-form-error *ngIf="photoPositionY.touched && photoPositionY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="photoPositionY.touched && photoPositionY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.photo.photoWidth' | translate }}" 
            formControlName="width" data-cy="photoWidth">
            <app-form-error *ngIf="photoWidth.touched && photoWidth.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="photoWidth.touched && photoWidth.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
      
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.photo.photoHeight' | translate }}" 
            formControlName="height" data-cy="photoHeight">
            <app-form-error *ngIf="photoHeight.touched && photoHeight.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="photoHeight.touched && photoHeight.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
      </section>
  
      <section formGroupName="address">
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.address.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" formControlName="display" [showMessages]="false"></app-form-checkbox>
        </div>
        <div class="row" *ngIf="addressDisplay.value">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.address.addressPositionX' | translate }}"
            formControlName="x" data-cy="addressPositionX">
            <app-form-error *ngIf="addressPositionX.touched && addressPositionX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="addressPositionX.touched && addressPositionX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.address.addressPositionY' | translate }}"
            formControlName="y" data-cy="addressPositionY">
            <app-form-error *ngIf="addressPositionY.touched && addressPositionY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="addressPositionY.touched && addressPositionY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
      </section>
  
      <section formGroupName="scanCode">
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.scan-code.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" formControlName="display" [showMessages]="false"></app-form-checkbox>
        </div>
        <div class="row" *ngIf="scanCodeDisplay.value">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.scan-code.scanCodePositionX' | translate }}" 
            formControlName="x" data-cy="scanCodePositionX">
            <app-form-error *ngIf="scanCodePositionX.touched && scanCodePositionX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="scanCodePositionX.touched && scanCodePositionX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.scan-code.scanCodePositionY' | translate }}" 
            formControlName="y" data-cy="scanCodePositionY">
            <app-form-error *ngIf="scanCodePositionY.touched && scanCodePositionY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="scanCodePositionY.touched && scanCodePositionY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.scan-code.scanCodeWidth' | translate }}" 
            formControlName="width" data-cy="scanCodeWidth">
            <app-form-error *ngIf="scanCodeWidth.touched && scanCodeWidth.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="scanCodeWidth.touched && scanCodeWidth.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.scan-code.scanCodeHeight' | translate }}" 
            formControlName="height" data-cy="scanCodeHeight">
            <app-form-error *ngIf="scanCodeHeight.touched && scanCodeHeight.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="scanCodeHeight.touched && scanCodeHeight.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
      </section>
  
      <section formGroupName="cardCode">
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.code.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" formControlName="display" [showMessages]="false"></app-form-checkbox>
        </div>
        <div class="row" *ngIf="cardCodeDisplay.value">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.code.cardCodeX' | translate }}"
            formControlName="x" data-cy="cardCodeX">
            <app-form-error *ngIf="cardCodeX.touched && cardCodeX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="cardCodeX.touched && cardCodeX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.code.cardCodeY' | translate }}"
            formControlName="y" data-cy="cardCodeY">
            <app-form-error *ngIf="cardCodeY.touched && cardCodeY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="cardCodeY.touched && cardCodeY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
      </section>
  
      <section formGroupName="residency">
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.residency.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" formControlName="display" [showMessages]="false"></app-form-checkbox>
        </div>
        <div class="row" *ngIf="residencyDisplay.value">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.residency.residencyPositionX' | translate }}"
            formControlName="x" data-cy="residencyPositionX">
            <app-form-error *ngIf="residencyPositionX.touched && residencyPositionX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="residencyPositionX.touched && residencyPositionX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.residency.residencyPositionY' | translate }}"
            formControlName="y" data-cy="residencyPositionY">
            <app-form-error *ngIf="residencyPositionY.touched && residencyPositionY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="residencyPositionY.touched && residencyPositionY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
      </section>
  
      <section formGroupName="cardType">
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.card-type.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" formControlName="display" [showMessages]="false"></app-form-checkbox>
        </div>
        <div class="row" *ngIf="cardTypeDisplay.value">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.card-type.cardTypePositionX' | translate }}"
            formControlName="x" data-cy="cardTypePositionX">
            <app-form-error *ngIf="cardTypePositionX.touched && cardTypePositionX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="cardTypePositionX.touched && cardTypePositionX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.card-type.cardTypePositionY' | translate }}"
            formControlName="y" data-cy="cardTypePositionY">
            <app-form-error *ngIf="cardTypePositionY.touched && cardTypePositionY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="cardTypePositionY.touched && cardTypePositionY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
      </section>
  
      <section formGroupName="expiration">
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.expiration.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" formControlName="display" [showMessages]="false"></app-form-checkbox>
        </div>
        <div class="row" *ngIf="expirationDisplay.value" formGroupName="rectangle">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.expiration.rectangleX' | translate }}"
            formControlName="x" data-cy="rectangleX">
            <app-form-error *ngIf="rectangleX.touched && rectangleX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="rectangleX.touched && rectangleX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.expiration.rectangleY' | translate }}"
            formControlName="y" data-cy="rectangleY">
            <app-form-error *ngIf="rectangleY.touched && rectangleY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="rectangleY.touched && rectangleY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.expiration.rectangleHeight' | translate }}"
            formControlName="height" data-cy="rectangleHeight">
            <app-form-error *ngIf="rectangleHeight.touched && rectangleHeight.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="rectangleHeight.touched && rectangleHeight.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.expiration.rectangleWidth' | translate }}"
            formControlName="width" data-cy="rectangleWidth">
            <app-form-error *ngIf="rectangleWidth.touched && rectangleWidth.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="rectangleWidth.touched && rectangleWidth.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
        <div class="row" *ngIf="expirationDisplay.value">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.expiration.expirationDateX' | translate }}"
            formControlName="x" data-cy="expirationDateX">
            <app-form-error *ngIf="expirationDateX.touched && expirationDateX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="expirationDateX.touched && expirationDateX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.expiration.expirationDateY' | translate }}"
            formControlName="y" data-cy="expirationDateY">
            <app-form-error *ngIf="expirationDateY.touched && expirationDateY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="expirationDateY.touched && expirationDateY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
        <div class="row" *ngIf="expirationDisplay.value">
          <h4>{{ 'pages.config-all.config-cards.config-print-cards.expiration.stringType.label' | translate }}</h4>
        </div>
        <div class="row column" *ngIf="expirationDisplay.value">
          <app-form-radio 
            [enableMessages]="false"
            [val]="expirationDateStringStyleOptions.SHORT"
            data-cy="short"
            formControlName="stringType"
          >
            {{ 'pages.config-all.config-cards.config-print-cards.expiration.stringType.short' | translate }}
          </app-form-radio>
          <app-form-radio
            [enableMessages]="false" 
            [val]="expirationDateStringStyleOptions.NUMERIC" 
            data-cy="numeric" 
            formControlName="stringType"
          >
            {{ 'pages.config-all.config-cards.config-print-cards.expiration.stringType.numeric' | translate }}
          </app-form-radio>
        </div>
      </section>

      <section formGroupName="orgLogo">
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.orgLogo.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" formControlName="display" [showMessages]="false"></app-form-checkbox>
        </div>
        <div class="row" *ngIf="orgLogoDisplay.value">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.orgLogo.positionX' | translate }}"
            formControlName="x" data-cy="orgLogoPositionX">
            <app-form-error *ngIf="orgLogoX.touched && orgLogoX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="orgLogoX.touched && orgLogoX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
      
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.orgLogo.positionY' | translate }}"
            formControlName="y" data-cy="orgLogoPositionY">
            <app-form-error *ngIf="orgLogoY.touched && orgLogoY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="orgLogoY.touched && orgLogoY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.orgLogo.width' | translate }}" 
            formControlName="width" data-cy="orgLogoWidth">
            <app-form-error *ngIf="orgLogoWidth.touched && orgLogoWidth.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="orgLogoWidth.touched && orgLogoWidth.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
      
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.orgLogo.height' | translate }}" 
            formControlName="height" data-cy="orgLogoHeight">
            <app-form-error *ngIf="orgLogoHeight.touched && orgLogoHeight.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="orgLogoHeight.touched && orgLogoHeight.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
      </section>

      <section formGroupName="bcitiLogo">
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.bcitiLogo.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" formControlName="display" [showMessages]="false"></app-form-checkbox>
        </div>
        <div class="row" *ngIf="bcitiLogoDisplay.value">
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.bcitiLogo.positionX' | translate }}"
            formControlName="x" data-cy="bcitiLogoPositionX">
            <app-form-error *ngIf="bcitiLogoX.touched && bcitiLogoX.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="bcitiLogoX.touched && bcitiLogoX.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
      
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.bcitiLogo.positionY' | translate }}"
            formControlName="y" data-cy="bcitiLogoPositionY">
            <app-form-error *ngIf="bcitiLogoY.touched && bcitiLogoY.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="bcitiLogoY.touched && bcitiLogoY.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
    
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.bcitiLogo.width' | translate }}" 
            formControlName="width" data-cy="bcitiLogoWidth">
            <app-form-error *ngIf="bcitiLogoWidth.touched && bcitiLogoWidth.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="bcitiLogoWidth.touched && bcitiLogoWidth.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
      
          <app-form-input class="number-input" (keydown.enter)="refreshPDF()" label="{{ 'pages.config-all.config-cards.config-print-cards.bcitiLogo.height' | translate }}" 
            formControlName="height" data-cy="bcitiLogoHeight">
            <app-form-error *ngIf="bcitiLogoHeight.touched && bcitiLogoHeight.hasError('required')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.required' | translate }}
            </app-form-error>
            <app-form-error *ngIf="bcitiLogoHeight.touched && bcitiLogoHeight.hasError('pattern')">
              {{ 'pages.config-all.config-cards.config-print-cards.errors.invalid' | translate }}
            </app-form-error>
          </app-form-input>
        </div>
      </section>

      <section>
        <div class="row">
          <h3>{{ 'pages.config-all.config-cards.config-print-cards.outlineCuttingHelp.heading' | translate }}</h3>
          <app-form-checkbox class="checkbox" (change)="refreshPDF()" formControlName="outlineCuttingHelp" [showMessages]="false"></app-form-checkbox>
        </div>
      </section>

    </div>
    <div class="row button-container">
      <button class="bciti-button" [ngClass]="loading || !selectedCodeStyle ? 'bciti-button--disabled' : 'bciti-button--red'" [disabled]="loading || !selectedCodeStyle"
        (click)="resetAllValues()">{{ 'pages.config-all.config-cards.config-print-cards.buttons.reset' | translate }}</button>
  
      <div class="preview-save">
        <button class="bciti-button" [ngClass]="loading || !selectedCodeStyle || !printTemplateForm.valid ? 'bciti-button--disabled' : 'bciti-button--blue'"
          [disabled]="loading || !selectedCodeStyle || !printTemplateForm.valid" (click)="refreshPDF()">
          {{ 'pages.config-all.config-cards.config-print-cards.buttons.preview' | translate}}
        </button>
        <button class="bciti-button" [ngClass]="loading || !selectedCodeStyle || processingSubmit || !printTemplateForm.valid ? 'bciti-button--disabled' : 'bciti-button--blue'"
          [disabled]="loading || !selectedCodeStyle || processingSubmit || !printTemplateForm.valid" (click)="submit()">
          <span *ngIf="!processingSubmit">{{ 'pages.config-all.config-cards.config-print-cards.buttons.save' | translate }}</span>
          <span class="submit-loader"><mat-spinner diameter="20" *ngIf="processingSubmit"></mat-spinner></span>
        </button>
      </div>
    </div>
    <div class="iframe-container" *ngIf="displayPreview">
        <ngx-qrcode 
          class="hidden" 
          id="qrcode" 
          [elementType]="qrcodeOpt.elementType" 
          [errorCorrectionLevel]="qrcodeOpt.correctionLevel" 
          [value]="qrCodeForImage"
        ></ngx-qrcode>
        <ngx-barcode6 
          class="hidden" 
          bc-format="CODE39" 
          bc-width=1 
          [bc-value]="cardExample.code" 
          [bc-display-value]="false"
        ></ngx-barcode6>
      <img class="hidden" id='barcode'>
      <iframe class="responsive-iframe" *ngIf="cardPDF" [src]="cardPDF"></iframe>
    </div>
  </section>